

















































































































































































































































































































































































































































import { cloneDeep, omit } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import {
  IAttachment,
  WorkflowFormTemplateAttachment,
  WorkflowFormTemplateRevision,
  IWorkflowFormSectionData,
  WorkflowFormTemplate,
  IWorkflowFormTemplate,
  IWorkflowFormTemplateData,
  IWorkflowFormTemplateRevisionData,
  IWorkflowFormTemplateRevision,
  MAX_PREFIX_LENGTH,
  SystemError,
  IWorkflowFormTemplateConfigHeaderData,
  WorkflowFormTemplatePrefixTypeEnum,
  IUser
} from '@/models';
import { Group } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';

import {
  diffDeep,
  getPropertyFromItem,
  setErrorFromAxiosError,
  scrollToBottomOfHtmlElement,
  convertObjectIdsToNumbers
} from '@/utils/helpers';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import snackbarMixin from '@/mixins/snackbar';
import draggable from '@/mixins/draggable';
import formRulesMixin from '@/mixins/file-upload-rules';

import { ISystemError } from '@/models/error/error.types';

import { requiredValidator } from '@/utils/validators';

import { ALForm } from '@/common/component.types';
import ALDialog from '../core/Dialog/ALDialog.vue';
import DragDropFileInput from '@/components/common/DragDropFileInput.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import GroupAutoCompletePicker from '@/components/account/GroupAutoCompletePicker.vue';
import NoDataAvailablePlaceholder from '../common/NoDataAvailablePlaceholder.vue';
import WorkflowAutoCompletePicker from '@/components/workflows/WorkflowAutoCompletePicker.vue';
import DeleteConfirmationDialog from '@/components/common/DeleteConfirmationDialog.vue';
import WorkflowFormTemplateStakeholderUsersAutoCompletePicker from '@/components/workflow-form-builder/WorkflowFormTemplateStakeholderUsersAutoCompletePicker.vue';
import WorkflowFormTemplateStakeholderUserProvider from './WorkflowFormTemplateStakeholderUserProvider.vue';

const baseMixins = mixins(auth, draggable, formRulesMixin, snackbarMixin);

export enum WizardSteps {
  Form,
  Attachments
}

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
    attachmentForm: ALForm;
    groupAutoCompletePickerRef: InstanceType<typeof GroupAutoCompletePicker>;
    userAutoCompletePickerRef: InstanceType<
      typeof WorkflowFormTemplateStakeholderUsersAutoCompletePicker
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'WorkflowFormTemplateWizardFormDialog',

    components: {
      ALDialog,
      DragDropFileInput,
      DeleteConfirmationDialog,
      ErrorAlert,
      GroupAutoCompletePicker,
      NoDataAvailablePlaceholder,
      WorkflowAutoCompletePicker,
      WorkflowFormTemplateStakeholderUsersAutoCompletePicker,
      WorkflowFormTemplateStakeholderUserProvider
    },

    data() {
      return {
        dialog: false,
        loading: false,
        formValid: false,
        attachmentsFormValid: false,

        isEdit: false,

        formTemplateData: {
          attachments: [],
          stakeholder_groups: [] as number[],
          stakeholder_users: [] as number[]
        } as IWorkflowFormTemplateData,

        templateRevisionData: {
          config: {
            headers: [] as IWorkflowFormTemplateConfigHeaderData[]
          }
        } as IWorkflowFormTemplateRevisionData,

        error: null as ISystemError | null,
        MAX_PREFIX_LENGTH,

        step: WizardSteps.Form,
        WorkflowFormTemplatePrefixTypeEnum,
        WizardSteps,

        attachment: null as File | null,

        attachmentDeleteDialog: false,
        isAttachmentDeleteInProgress: false,
        attachmentDeleteError: null as ISystemError | null,
        selectedAttachment: null as null | IAttachment
      };
    },

    computed: {
      ...mapGetters({
        getWorkflowFormTemplateRevisionById:
          'workflowFormTemplate/getWorkflowFormTemplateRevisionById',
        getWorkflowFormTemplatePrefixTypeVisuals:
          'workflowFormTemplate/getWorkflowFormTemplatePrefixTypeVisuals',

        getWorkflowFormTemplateById:
          'workflowFormTemplate/getWorkflowFormTemplateById',
        getLastCreatedWorkflowFormTemplateId:
          'workflowFormTemplate/getLastCreatedWorkflowFormTemplateId'
      }),

      title(): string {
        switch (this.step) {
          case WizardSteps.Form:
            return 'Form Template Builder';
          case WizardSteps.Attachments:
          default:
            return 'Form Template Builder Attachments';
        }
      },

      groupsProvider(): any {
        return this.$altoleapAccounts.groupsProvider;
      },

      proxyTemplateConfigHeaders: {
        get(): IWorkflowFormTemplateConfigHeaderData[] {
          return this.formTemplateData.config
            ? this.formTemplateData.config.headers!
            : [];
        },
        set(value: IWorkflowFormTemplateConfigHeaderData[]) {
          this.formTemplateData.config!.headers = value;
        }
      },

      computedStakeholderGroups(): Group[] {
        let groups = [];

        groups = this.formTemplateData.stakeholder_groups!.map(
          (group: number | Group) => {
            if (typeof group === 'number') {
              return this.groupsProvider.getGroupById(group);
            } else {
              return group;
            }
          }
        );

        return groups;
      },

      workflowFormTemplateRevision(): IWorkflowFormTemplateRevision {
        return this.getWorkflowFormTemplateRevisionById(
          this.templateRevisionData.id
        );
      },

      workflowFormTemplate(): IWorkflowFormTemplate {
        return this.getWorkflowFormTemplateById(this.formTemplateData.id);
      }
    },

    methods: {
      requiredValidator,
      ...mapActions({
        createWorkflowFormTemplate:
          'workflowFormTemplate/createWorkflowFormTemplate',
        updateWorkflowFormTemplate:
          'workflowFormTemplate/updateWorkflowFormTemplate',
        createWorkflowFormTemplateRevision:
          'workflowFormTemplate/createWorkflowFormTemplateRevision',
        updateWorkflowFormTemplateRevision:
          'workflowFormTemplate/updateWorkflowFormTemplateRevision',
        addWorkflowFormTemplateAttachment:
          'workflowFormTemplate/addWorkflowFormTemplateAttachment',
        removeWorkflowFormTemplateAttachment:
          'workflowFormTemplate/removeWorkflowFormTemplateAttachment'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      validateAttachmentForm(): boolean {
        let valid = false;
        if (this.$refs.attachmentForm) {
          valid = this.$refs.attachmentForm.validate();
        }
        return valid;
      },

      moveToAttachmentsForm() {
        if (this.validateForm()) {
          this.attachment = null;
          this.step = WizardSteps.Attachments;
        }
      },

      addConfigHeader() {
        const headersLength = this.formTemplateData.config!.headers!.length;
        this.formTemplateData.config!.headers!.push({
          meta_label: '',
          display_label: '',
          order: headersLength + 1,
          width: 0
        });
      },

      open(
        revision?: IWorkflowFormTemplateRevision,
        step: WizardSteps = WizardSteps.Form
      ) {
        this.clearAllErrors();

        this.resetFormValidation();

        this.formTemplateData =
          revision && revision.template
            ? cloneDeep(revision.template)
            : {
                attachments: [],
                stakeholder_groups: [] as number[],
                stakeholder_users: [] as number[]
              };

        this.templateRevisionData = revision
          ? cloneDeep(revision)
          : ({
              series_origin: 1,
              sections: [
                {
                  title: 'Section 1',
                  order: 0,
                  section_fields: []
                } as IWorkflowFormSectionData
              ],
              config: {
                headers: [] as IWorkflowFormTemplateConfigHeaderData[]
              }
            } as IWorkflowFormTemplateRevisionData);

        this.isEdit = !!revision?.id;

        this.step = step;

        this.dialog = true;
      },

      close() {
        this.dialog = false;
      },

      updateStakeholderGroup(groupId: number) {
        // groupId may be a number or an object depending if the value is coming from the server or locally
        const groupIndex = this.formTemplateData.stakeholder_groups!.findIndex(
          permissionGroup => {
            const permissionGroupId =
              typeof permissionGroup === 'number'
                ? permissionGroup
                : getPropertyFromItem(permissionGroup, 'id', permissionGroup);
            return groupId === permissionGroupId;
          }
        );

        // if tag not currently in tag list as to not add duplicates
        if (groupIndex === -1) {
          this.formTemplateData.stakeholder_groups!.push(groupId);
        } else {
          this.removeStakeholderGroup(groupId);
        }

        this.$nextTick(() => {
          this.$refs.groupAutoCompletePickerRef.reset();
        });
      },

      removeStakeholderGroup(groupId: number) {
        // group may be a number or an object depending if the value is coming from the server or locally
        const groupIndex = this.formTemplateData.stakeholder_groups!.findIndex(
          permissionGroup => {
            const permissionGroupId =
              typeof permissionGroup === 'number'
                ? permissionGroup
                : getPropertyFromItem(permissionGroup, 'id', permissionGroup);
            return groupId === permissionGroupId;
          }
        );

        this.formTemplateData.stakeholder_groups!.splice(groupIndex, 1);
      },

      updateStakeholderUser(userId: number) {
        // userId may be a number or an object depending if the value is coming from the server or locally
        const userIndex = this.formTemplateData.stakeholder_users!.findIndex(
          user => {
            const permissionUserId =
              typeof user === 'number'
                ? user
                : getPropertyFromItem(user, 'id', user);
            return userId === permissionUserId;
          }
        );

        // if tag not currently in tag list as to not add duplicates
        if (userIndex === -1) {
          this.formTemplateData.stakeholder_users!.push(userId);
        } else {
          this.removeStakeholderUser(userId);
        }

        this.$nextTick(() => {
          this.$refs.userAutoCompletePickerRef.reset();
        });
      },

      removeStakeholderUser(userId: number) {
        // user may be a number or an object depending if the value is coming from the server or locally
        const userIndex = this.formTemplateData.stakeholder_users!.findIndex(
          permissionUser => {
            const permissionUserId =
              typeof permissionUser === 'number'
                ? permissionUser
                : getPropertyFromItem(permissionUser, 'id', permissionUser);
            return userId === permissionUserId;
          }
        );

        this.formTemplateData.stakeholder_users!.splice(userIndex, 1);
      },

      openDeleteAttachmentDialog(attachment: IAttachment) {
        this.clearAllErrors();
        this.selectedAttachment = attachment;
        // Once the selected attachment is set then the attachment dialog is opened on the next frame to avoid a visual flicker of the data
        this.$nextTick(() => {
          this.attachmentDeleteDialog = true;
        });
      },

      cancelDeleteAttachmentDialog() {
        this.selectedAttachment = null;
        this.attachmentDeleteDialog = false;
      },

      removeAttachment(attachment: IAttachment) {
        this.clearAllErrors();
        this.isAttachmentDeleteInProgress = true;

        this.removeWorkflowFormTemplateAttachment({
          templateId: this.workflowFormTemplateRevision.template!.id,
          attachmentId: attachment.id
        })
          .then(() => {
            this.attachmentDeleteDialog = false;
          })
          .catch(error => {
            this.attachmentDeleteError = setErrorFromAxiosError(error);
          })
          .finally(() => {
            this.isAttachmentDeleteInProgress = false;
          });
      },

      uploadWorkflowFormTemplateAttachment() {
        if (this.validateAttachmentForm()) {
          this.clearAllErrors();

          let attachmentInstance: IAttachment | null = null;

          try {
            attachmentInstance = new WorkflowFormTemplateAttachment({
              file: this.attachment as File
            });
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }

          if (attachmentInstance != null) {
            this.loading = true;

            this.addWorkflowFormTemplateAttachment({
              templateId: this.formTemplateData.id,
              attachment: attachmentInstance
            })
              .then(() => {
                this.attachment = null;
                scrollToBottomOfHtmlElement('#attachments-list');
              })
              .catch(error => {
                this.error = setErrorFromAxiosError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      },

      saveAndClose() {
        if (!this.isEdit) {
          this.routeToTemplatePage(this.templateRevisionData).then(() => {
            this.createSnack({
              color: 'success darken-1',
              type: 'info',
              right: true,
              msg: 'Template created',
              timeout: 4000
            });
          });
        } else {
          this.$emit('saved');
          this.close();
        }
      },

      saveTemplate() {
        this.clearAllErrors();
        if (this.validateForm()) {
          let templateInstance: IWorkflowFormTemplate | null = null;

          try {
            templateInstance = new WorkflowFormTemplate(this.formTemplateData);
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }

          if (templateInstance != null) {
            this.loading = true;

            const saveAction = !templateInstance.id
              ? this.createWorkflowFormTemplate
              : this.updateWorkflowFormTemplate;

            let payload = templateInstance;

            if (templateInstance.id) {
              payload = diffDeep(
                templateInstance,
                this.getWorkflowFormTemplateById(templateInstance.id),
                true
              );

              // convert the payload lists members to ids and not objects
              if (payload.stakeholder_groups) {
                payload.stakeholder_groups = convertObjectIdsToNumbers(
                  payload.stakeholder_groups!
                );
              }

              if (payload.stakeholder_users) {
                payload.stakeholder_users = convertObjectIdsToNumbers(
                  payload.stakeholder_users!
                );
              }
            }

            saveAction(payload)
              .then(async () => {
                const formTemplate = payload.id
                  ? this.getWorkflowFormTemplateById(payload.id)
                  : this.getWorkflowFormTemplateById(
                      this.getLastCreatedWorkflowFormTemplateId
                    );
                this.formTemplateData = new WorkflowFormTemplate(formTemplate);
                this.templateRevisionData.template = this.formTemplateData;
                // wait for this function to end before going to final catch
                await this.saveTemplateRevision();
              })
              .catch(error => {
                this.error = setErrorFromAxiosError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      },

      saveTemplateRevision() {
        this.clearAllErrors();
        if (this.validateForm()) {
          let revisionInstance: IWorkflowFormTemplateRevision | null = null;

          try {
            revisionInstance = new WorkflowFormTemplateRevision(
              omit(this.templateRevisionData, ['template'])
            );
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }
          if (revisionInstance != null) {
            this.loading = true;

            const saveAction = !revisionInstance.id
              ? this.createWorkflowFormTemplateRevision
              : this.updateWorkflowFormTemplateRevision;

            let payload = revisionInstance;

            if (revisionInstance.id) {
              payload = diffDeep(
                revisionInstance,
                this.getWorkflowFormTemplateRevisionById(revisionInstance.id),
                true
              );
            }

            return saveAction({
              templateId: this.formTemplateData.id,
              revision: payload
            })
              .then(template => {
                this.templateRevisionData = !this.isEdit
                  ? new WorkflowFormTemplateRevision(template)
                  : this.workflowFormTemplateRevision;

                this.$emit('saved');

                this.moveToAttachmentsForm();
              })
              .catch(error => {
                this.error = setErrorFromAxiosError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      },

      updateHeaderOrder() {
        this.isDragging = false;

        this.clearAllErrors();

        // using proxyItems as the value itself is updated before function is called
        this.proxyTemplateConfigHeaders.map((item, index: number) => {
          if (item.order !== index + 1) {
            item.order = index + 1;
          }
          return item;
        });
      },

      routeToTemplatePage(revision: IWorkflowFormTemplateRevisionData) {
        return this.$router.push({
          name: 'workflow-form-template-detail',
          params: {
            templateId: String(revision.template!.id),
            revisionId: String(revision.id)
          }
        });
      },

      clearAllErrors() {
        this.error = null;
      },

      removeHeader(index: number): void {
        this.proxyTemplateConfigHeaders.splice(index, 1);
      }
    }
  });
